import { useState, useMemo } from 'react';

import { isDocumentAvailable } from '../utils/browserObjectsAvailability';

export const useCopyToClipboard = (elementRef) => {
  const [copySuccess, setCopySuccess] = useState(null);
  const isSupported = useMemo(() => {
    if (isDocumentAvailable()) {
      return document.queryCommandSupported('copy');
    }

    return false;
  }, [isDocumentAvailable]);

  function copyToClipboard() {
    if (!isDocumentAvailable()) {
      setCopySuccess(false);

      return;
    }

    elementRef.current.select();
    document.execCommand('copy');
    setCopySuccess(true);
  }

  return [{ copySuccess, isSupported }, { copyToClipboard }];
};
